import type { AdminUsageSeatRow } from '@nadoutong/contracts';
import type { SheetCell, SheetSpec } from './types.ts';
import { centsToYuan, moneyYuan } from './money.ts';

/** Chinese headers for the admin usage (seat) sheet — always zh, per #178. */
export const USAGE_SHEET_HEADERS: readonly string[] = [
  '成员',
  '邮箱',
  '账号 ID',
  '状态',
  '组织单元',
  '主模型',
  '输入 Token',
  '输出 Token',
  '缓存写 Token',
  '缓存读 Token',
  '请求数',
  '成功请求',
  '错误请求',
  '平均每请求 Token',
  '费用（元）',
  '月度上限（元）',
];

export const USAGE_SHEET_NAME = '用量明细';

const SEAT_STATUS_LABEL: Readonly<Record<AdminUsageSeatRow['status'], string>> = {
  active: '正常',
  disabled: '已停用',
  deleted: '已移除',
};

export function assembleUsageSheet(
  rows: readonly AdminUsageSeatRow[],
  cnyPerUsd: number | null,
): SheetSpec {
  return {
    name: USAGE_SHEET_NAME,
    rows: [USAGE_SHEET_HEADERS, ...rows.map((row) => usageRow(row, cnyPerUsd))],
  };
}

function usageRow(row: AdminUsageSeatRow, cnyPerUsd: number | null): readonly SheetCell[] {
  return [
    row.memberName ?? row.email ?? row.memberAccountId,
    row.email ?? '',
    row.memberAccountId,
    SEAT_STATUS_LABEL[row.status],
    row.department ?? '',
    row.primaryModel ?? row.defaultModel ?? '',
    row.inputTokens,
    row.outputTokens,
    row.cacheWriteTokens,
    row.cacheReadTokens,
    row.requests,
    row.successRequests,
    row.errorRequests,
    row.averageTokensPerRequest,
    moneyYuan(row.costUsdMicros, row.costUsdCents, cnyPerUsd),
    centsToYuan(row.monthlyLimitUsdCents, cnyPerUsd),
  ];
}
